<template>
  <section id="footer">
    <div class="container desktop">

      <div class="row links">

        <div class="col logo">
          <div class="logo-footer">
            <logo layout="horizontal"/>
          </div>
        </div>

        <div id="footer-menu">
            <ul>
            <li><a :href="link('dealers')" v-translate="'MENU_dealers'"></a></li>
            <li><a href="/zwroty" v-if="language=='pl'">Zwroty</a></li>
            <li><a :href="link('warranty')" v-if="language=='pl'" v-translate="'MENU_warranty'"></a></li>
              <li v-if="language=='pl'"><a href="/informacje-o-leasingu">Informacje o leasingu</a></li>
            <li><a :href="link('privacy-policy')" v-translate="'MENU_privacy_policy'"></a></li>
            <li><a :href="link('rules')" v-translate="'MENU_rules'"></a></li>
            <li><a :href="link('contact')" v-translate="'MENU_contact'"></a></li>

          </ul>
        </div>

        <div class="col icons">
          <a class="icon facebook" :href="getSocialLink('facebook')" target=_blank></a>
          <a class="icon instagram" :href="getSocialLink('instagram')" target=_blank></a>
          <a class="icon spacer"></a>
          <div class="languages">
            <flags></flags>
            <div class="language-select">
              <flags :key="langCode" v-for="langCode in languages" :lang="langCode"></flags>
              <div class="arrow-right">
                <svg viewBox="0 0 12 10">
                  <polygon fill="#4AA3A0" points="0,10 0,0 12,5 "/>
                </svg>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="container mobile">

      <div class="row links">

        <div class="col icons">
          <a class="icon facebook" :href="getSocialLink('facebook')" target=_blank></a>
          <a class="icon instagram" :href="getSocialLink('instagram')" target=_blank></a>
        </div>

        <div class="col logo">
          <div class="logo-footer">
            <logo layout="vertical"/>
          </div>
        </div>

        <div class="languages">
          <flags></flags>
          <div class="language-select">
            <flags :key="langCode" v-for="langCode in languages" :lang="langCode"></flags>
            <div class="arrow-right">
              <svg viewBox="0 0 12 10">
                <polygon fill="#4AA3A0" points="0,10 0,0 12,5 "/>
              </svg>
            </div>
          </div>
        </div>

      </div><!-- //row -->
    </div>

    <div class='container'>
      <div class="row">
        <p v-translate="'ftr_copyrights'"></p>
        <p class="desktop">&nbsp;</p>
        <p v-translate="'ftr_privacy'"></p>
      </div>
    </div>

  </section>
</template>

<script>
  import Logo from '../Graphics/Logo.vue'
  import Flags from '../Graphics/Flags.vue'

  export default {
    name: 'Footer',
    components: {Logo, Flags},
    data() {
      return {
        language: window.env.language,
        languages: window.env.languages
      }
    },
    methods: {
      link(to) {
        return window.env.baseUrl + window.translations['rt_' + to];
      },
      getSocialLink: function (id) {
        return env[id]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Blocks/Footer.vue